import { Box, ModBox } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useRef, useState } from 'react'
import { ImageWithInfoSerializer } from '../../comps/ImageWithInfoSerializer/ImageWithInfoSerializer'
import { TableComponent } from '../../comps/TableComponent'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { hyphenSeparatedDate } from '../../util/billPaymentUtil'
import { TransactionCard } from '../BillPayments/TransactionCard'
import { SearchBar } from './SearchBar'

export const SearchTxns = () => {
  const [searchString, setSearchString] = useState('')
  const { data, updateTransactionOrder, searchByOrderIdApi } = useStores((root) => ({
    data: root.billPayments.orders,
    updateTransactionOrder: root.billPayments.updateTransactionOrder,
    searchByOrderIdApi: root.billPayments.searchByOrderIdApi,
  }))
  const abortControllerRef = useRef<AbortController>()

  const [searchByOrderId, { state: searchState, data: searchData }] = useLazyApiData(searchByOrderIdApi)

  const navigation = useNavigation()

  useEffect(() => {
    if (searchState === 'fulfilled') {
      if (searchData?.length) {
        const txn = searchData?.[0]
        updateTransactionOrder({
          ...txn,
          shortName: txn.product.name,
          timeStamp: hyphenSeparatedDate(new Date(txn?.payment?.paymentAt), 'dd-mm-yyyy hh:mm:ss'),
        })
        navigation.navigate(Routes.BILL_PAYMENTS_TRANSACTIONS_DETAILS as never, { data: txn } as never)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState])

  const handleSearchClick = (val: string) => {
    setSearchString(val)
    if (val !== '') {
      abortControllerRef?.current?.abort()
      abortControllerRef.current = new AbortController()
      searchByOrderId(val, abortControllerRef.current)
    }
  }

  const renderItem = ({ item, index }) => {
    const onSelect = (txn: any) => {
      updateTransactionOrder({
        ...txn,
        shortName: txn.product.name,
        timeStamp: hyphenSeparatedDate(new Date(txn?.payment?.paymentAt), 'dd-mm-yyyy hh:mm:ss'),
      })
      // navigate to transaction detail screen
      navigation.navigate(Routes.BILL_PAYMENTS_TRANSACTIONS_DETAILS as never, { data: txn } as never)
    }
    return (
      <Box ph={24}>
        <TransactionCard item={item} onSelect={onSelect} />
      </Box>
    )
  }
  if (!data?.length) {
    return null
  }
  return (
    <Box bg={'SECONDARY'} f={1} pt={64}>
      <Box bg={'WHITE'} f={1} borderTopLeftRadius={24} borderTopRightRadius={24} pv={24}>
        <SearchBar onSearchPress={handleSearchClick} setSearchString={setSearchString} searchString={searchString} />
        <ModBox
          show={searchData?.length === 0 && searchString?.length > 0}
          align={'center'}
          justify={'center'}
          f={1}
          bg={'WHITE'}>
          <ImageWithInfoSerializer screenName={Routes.SEARCH} searchString={searchString} />
        </ModBox>
        <ModBox pt={10} bg={'WHITE'} f={1} show={!(searchData?.length === 0 && searchString?.length > 0)}>
          <TableComponent
            ListContent={searchData}
            value={''}
            RenderCustomElement={renderItem}
            isCustom={true}
            scrollEnabled
            hide={searchData?.length === 0}
            canFetchMore={false}
            extraData={searchData}
          />
        </ModBox>
      </Box>
    </Box>
  )
}
